import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email: formData.email,
        password: formData.password
      });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('userRole', response.data.user.role || 'staff');
      toast.success(`Welcome, ${response.data.user.username}!`);
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center" style={{ backgroundImage: `url('https://images.pexels.com/photos/1963218/pexels-photo-1963218.jpeg')`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className="noise-overlay" />
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />
      
      <div className="relative z-10 w-full max-w-md mx-4">
        <div className="bg-white/95 backdrop-blur-md rounded-md shadow-2xl p-8 border border-concrete-200">
          <div className="text-center mb-8">
            <h1 className="font-manrope font-bold text-4xl text-brick-600 mb-2" data-testid="app-title">DHAYA BRICKS</h1>
            <p className="font-inter text-concrete-600">Salary & Stock Management</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="font-manrope font-semibold uppercase tracking-wider text-xs text-concrete-700">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="email-input"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="mt-2 border-concrete-300 focus:border-brick-500 focus:ring-brick-500/20"
                placeholder="Enter your email"
                required
              />
            </div>
            
            <div>
              <Label htmlFor="password" className="font-manrope font-semibold uppercase tracking-wider text-xs text-concrete-700">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="password-input"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="mt-2 border-concrete-300 focus:border-brick-500 focus:ring-brick-500/20"
                placeholder="Enter your password"
                required
              />
            </div>

            <Button
              type="submit"
              data-testid="submit-button"
              disabled={isLoading}
              className="w-full bg-brick-600 hover:bg-brick-500 text-white shadow-md hover:shadow-lg transition-all duration-200 font-manrope font-semibold rounded-md py-6"
            >
              <LogIn className="mr-2 h-4 w-4" />
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-concrete-500">
            <p>Contact admin for login credentials</p>
          </div>
        </div>
      </div>
    </div>
  );
}
